<template>
  <div class="login">
    <div class="login-cointainer">
      <div class="notfound-desc">
        <img :src="require('@/assets/smile.png')" alt class="notfound-img" />
      </div>
      <div class="tips">温馨提示</div>

      <p class="notfound-desc">首次验审请先提交人脸信息！</p>

      <div class="login-btn">
        <span @click="handleNext">立即上传</span>
      </div>
    </div>
  </div>
</template>
<script>
import CommonTitle from "@/components/CommonTitle/Index";

export default {
  components: { CommonTitle, },
  data() {
    return {
      phone: "",
      type: 1,
      user_info: {},
      registerCode: "",
      password: "",
    };
  },
  methods: {
    handleNext(item) {
      if (this.type === 1) {
        this.$router.push("/uploadFace");
      }
      if (this.type === 2) {
        let url = `${window.location.href.split("#")[0]}#/headcertification`;
        console.log(url);
        location.assign(url);
      }
    },
    handleRecord() {
      this.$router.push("/record");
    },

    getType() {
      console.log(this.user_info);
      if (this.user_info.checkEnabled == false) {
        this.type = 0;
      } else if (this.user_info.timeout == true) {
        this.type = 3;
      } else if (this.user_info.haveFace == false) {
        console.log(this.type + "1");
        this.type = 1;
      } else if (
        this.user_info.haveFace == true &&
        this.user_info.haveChecked == false
      ) {
        this.type = 2;
        console.log(this.type);
      } else if (
        this.user_info.haveChecked == true &&
        this.user_info.haveFace == true
      ) {
        this.$router.push({ path: "/result" });
      }
    },
  },
  created() {
    this.user_info = JSON.parse(sessionStorage.getItem("user_info") || {});
    this.getType();
  },
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  &-cointainer {
    padding: 0 14px;
    text-align: center;
    .tips {
      font-size: 16px;
      font-family: PingFang SC;
      margin: 20px 0 10px;
      color: #777777;
      font-weight: 400;
    }
    .record {
      margin-top: 70px;
      display: inline-block;
      width: 109px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      background: #ffffff;
      border: 1px solid #2c66f8;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #2c66f8;
      border-radius: 3px;
    }
    .notfound {
      &-desc {
        text-align: center;
        font-size: 20px;
        line-height: 27px;
        color: #444545;
      }
      &-img {
        width: 70px;
        margin-top: 120px;
      }
      &-btn {
        padding: 12px 24px;
        background: #ffffff;
        border: 1px solid rgba(44, 102, 248, 1);
        border-radius: 4px;
        color: #2c66f8;
      }
    }
  }
  &-btn {
    position: fixed;
    left: 0;
    bottom: 50px;
    text-align: center;
    width: 100%;
    padding: 0 14px;
    > span {
      display: inline-block;
      line-height: 46px;
      text-align: center;
      width: 100%;
      height: 46px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      background: #2c66f8;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.17);
      border-radius: 4px;
    }
    > h2 {
      margin-top: 40px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      text-decoration: underline;
      color: #464747;
    }
  }
}
</style>
